import {toast} from 'react-toastify';
import api from '../irelandApi';
import {clear, setAuthorizationToken} from '../utils/tokenUtils';
import ToastMessage from '../components/common/toast-message';
import {PATCH_WELCOME_PENDING, PATCH_WELCOME_FULFILLED, PATCH_WELCOME_REJECTED} from '../reducers/welcomeReducer';

const ADMIN_MY_PROFILE_URL = '/admin/my-profile';
const ADMIN_INVITATION_URL = '/api/admin/users/invitation';
const TEAM_INVITATION_URL = '/api/team/users/invitation';
const TEAM_MY_PROFILE_URL = '/team/my-profile';

export const welcomeAction = (payload, dispatch) => {
  dispatch({type: PATCH_WELCOME_PENDING});
  return api.patch(ADMIN_INVITATION_URL, {user: payload})
    .then((response) => {
      const token = response.headers.authorization.split(' ')[1];
      clear();
      setAuthorizationToken(token);
      toast.success(<ToastMessage iconStyle="success" message="Your data has been successfully saved."/>);
      dispatch({
        type: PATCH_WELCOME_FULFILLED,
        payload: response.data
      });
      window.location.href = ADMIN_MY_PROFILE_URL;
    })
    .catch((error) => {
      dispatch({
        type: PATCH_WELCOME_REJECTED,
        payload: error.response.data.errors
      });

      if (typeof error.response.data.errors === 'string') {
        toast.error(<ToastMessage iconStyle="error" message={error.response.data.errors}/>);
      }

      return Promise.reject(error.response.data.errors);
    });
};

export const welcomeTeam = (payload, dispatch) => {
  dispatch({type: PATCH_WELCOME_PENDING});
  return api.patch(TEAM_INVITATION_URL, {user: payload})
    .then((response) => {
      const token = response.headers.authorization.split(' ')[1];
      clear();
      setAuthorizationToken(token);
      toast.success(<ToastMessage iconStyle="success" message="Your data has been successfully saved."/>);
      dispatch({
        type: PATCH_WELCOME_FULFILLED,
        payload: response.data
      });
      window.location.href = TEAM_MY_PROFILE_URL;
    })
    .catch((error) => {
      dispatch({
        type: PATCH_WELCOME_REJECTED,
        payload: error.response.data.errors
      });

      if (typeof error.response.data.errors === 'string') {
        toast.error(<ToastMessage iconStyle="error" message={error.response.data.errors}/>);
      }

      return Promise.reject(error.response.data.errors);
    });
};
